import { Box, Stack, Typography, Grid } from '@mui/material'
import { Description, Euro, Email, PeopleAlt, BarChart, Business, Receipt } from '@mui/icons-material'

export const WelcomeOnboarding = () => {
  const features = [
    {
      icon: <Description sx={{ fontSize: 48 }} />,
      title: 'Facturen & Offertes',
      description: 'Maak professionele facturen en offertes met een paar klikken',
    },
    {
      icon: <Euro sx={{ fontSize: 48 }} />,
      title: 'Betalingen Volgen',
      description: 'Houd betalingen bij en zie direct je openstaande bedragen',
    },
    {
      icon: <Email sx={{ fontSize: 48 }} />,
      title: 'Direct Versturen',
      description: 'Verstuur facturen per e-mail met PDF bijlage',
    },
    {
      icon: <PeopleAlt sx={{ fontSize: 48 }} />,
      title: 'Klantenbeheer',
      description: 'Centraal overzicht van alle klanten en contactpersonen',
    },
    {
      icon: <BarChart sx={{ fontSize: 48 }} />,
      title: 'Inzicht in je Business',
      description: 'Dashboard met omzet, openstaande facturen en top klanten',
    },
    {
      icon: <Business sx={{ fontSize: 48 }} />,
      title: 'KVK Integratie',
      description: 'Importeer bedrijfsgegevens direct vanuit de Kamer van Koophandel',
    },
    {
      icon: <Receipt sx={{ fontSize: 48 }} />,
      title: 'Creditnota\'s',
      description: 'Maak gemakkelijk creditnota\'s aan',
    },
  ]

  return (
    <Stack spacing={5}>
      {/* Hero Section - More compact */}
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            background: 'linear-gradient(315deg, #311b92 0%, #f50057 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 700,
            mb: 2,
          }}>
          Welkom bij Outvoice!
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 500, mx: 'auto', fontSize: '1.1rem' }}>
          Je administratie wordt nu een stuk eenvoudiger. Ontdek wat je allemaal kunt doen.
        </Typography>
      </Box>

      {/* Features Grid - Compact 4-column layout */}
      <Grid
        container
        spacing={2}
        sx={{ mt: 1 }}>
        {features.map(feature => (
          <Grid
            item
            xs={6}
            sm={4}
            md={3}
            key={feature.title}>
            <Box
              sx={{
                textAlign: 'center',
                p: 2.5,
                height: '100%',
                transition: 'all 0.2s ease',
                borderRadius: 2,
                cursor: 'default',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  '& .icon-box': {
                    transform: 'scale(1.1)',
                    boxShadow: '0 6px 16px rgba(49, 27, 146, 0.3)',
                  },
                },
              }}>
              {/* Compact Icon */}
              <Box
                className="icon-box"
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 1.5,
                  background: 'linear-gradient(315deg, #311b92 0%, #f50057 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 1.5,
                  mx: 'auto',
                  transition: 'all 0.2s',
                  boxShadow: '0 3px 8px rgba(49, 27, 146, 0.2)',
                }}>
                <Box
                  sx={{
                    color: 'white',
                    display: 'flex',
                    '& svg': { fontSize: 28 },
                  }}>
                  {feature.icon}
                </Box>
              </Box>
              {/* Compact Title */}
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  color: 'text.primary',
                  mb: 0.5,
                  fontSize: '0.95rem',
                }}>
                {feature.title}
              </Typography>
              {/* Compact Description */}
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: '0.875rem',
                  lineHeight: 1.4,
                }}>
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Call to Action - More subtle */}
      <Box
        sx={{
          p: 3,
          background: 'linear-gradient(315deg, #311b92 0%, #f50057 100%)',
          color: 'white',
          borderRadius: 2,
          textAlign: 'center',
          mt: 1,
          boxShadow: '0 4px 12px rgba(49, 27, 146, 0.2)',
        }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 0.5 }}>
          Klaar om te beginnen?
        </Typography>
        <Typography
          variant="body2"
          sx={{ opacity: 0.95 }}>
          Klik op <strong>Volgende</strong> om je profiel in te stellen en binnen 2 minuten je eerste factuur te
          versturen.
        </Typography>
      </Box>
    </Stack>
  )
}
